var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{attrs:{"options":{
                  streetViewControl: false,
                  mapTypeControl: false,
                  zoomControl: false,
                  fullscreenControl: false,
                  gestureHandling : 'none',},"center":{lat:_vm.store.lat, lng:_vm.store.lng},"zoom":16,"map-type-id":"terrain"}},[_c('GmapMarker',{attrs:{"clickable":false,"draggable":false,"position":{lat:_vm.store.lat, lng:_vm.store.lng}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dbf6352","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Elements/FullScreenMap.vue
// module id = null
// module chunks = 